module.exports = __webpack_public_path__ + "static/img/professional.865ff27e.svg";